import * as types from '../actions/emptyPanAction';

const initialState = {
  restaurantUuid: null,
  interval: null,
  startDate: null,
  endDate: null,
  timeInterval: null,
  intervalEnd: null,
  timezone: null,
  limit: '20',
  page: 0,
  totalResults: 0,
  loading: true,
  chartLoading: false,
  graphContent: [],
  data: [],
};

export const imagesCache = {};

const cacheImage = ({ eventId, index, image }) => {
  if (!imagesCache[eventId]) {
    imagesCache[eventId] = [];
  }
  imagesCache[eventId][index] = image;
};

const emptyPanReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_EMPTY_PAN_VALUE:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };

    case types.CHANGE_EMPTY_PAN_SEVERAL_VALUES:
      return {
        ...state,
        ...action.payload,
      };

    case types.CHANGE_EMPTY_PAN_CURRENT_IMAGE:
      return {
        ...state,
        data: state.data.map((item, index) =>
          index === action.payload.index ? { ...item, currentImage: action.payload.value } : item
        ),
      };

    case types.SET_EMPTY_PAN_EVENT_IMAGE:
      cacheImage(action.payload);
      return {
        ...state,
        data: state.data.map((item) => {
          if (item.eventId === action.payload.eventId) {
            const updatedImages = [...item.images];
            updatedImages.splice(action.payload.index, 1, action.payload.image);
            return { ...item, images: updatedImages };
          } else {
            return item;
          }
        }),
      };

    case types.GET_EMPTY_PAN:
      return {
        ...state,
        loading: true,
        data: [],
      };

    case types.GET_EMPTY_PAN_SUCCESS:
      return {
        ...state,
        loading: false,
        totalResults: action.payload.total,
        data: action.payload.content.map((item) => ({
          ...item,
          currentImage: 0,
          images: item.frames.map((fr, i) =>
            imagesCache[item.eventId] && imagesCache[item.eventId][i] ? imagesCache[item.eventId][i] : null
          ),
        })),
      };

    case types.GET_EMPTY_PAN_ERROR:
      return {
        ...state,
        loading: false,
      };

    case types.GET_EMPTY_PAN_ANALYTIC:
      return {
        ...state,
        chartLoading: true,
        graphContent: [],
      };

    case types.GET_EMPTY_PAN_ANALYTIC_SUCCESS:
      return {
        ...state,
        chartLoading: false,
        graphContent:
          action.payload.length !== 0
            ? action.payload[0].values.map((item, index) => [
                new Date(item[0] * 1000),
                action.payload.reduce(function (sum, elem) {
                  return sum + Number(elem.values[index][1]);
                }, 0),
              ])
            : [[0, 0]],
      };

    case types.GET_EMPTY_PAN_ANALYTIC_ERROR:
      return {
        ...state,
        chartLoading: false,
      };

    case types.RESET_EMPTY_PAN_STORE:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
};

export default emptyPanReducer;
